import React, { useEffect, useState } from "react";
import { Form, Row, Col, } from "react-bootstrap";
import { useNavigate, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchStandardSection } from "../../store/slices/getstandardsection";
import { getSubject, addClassSubject } from "../../store/slices/subject";
import { toast } from "react-hot-toast";
import {
  FiHome,
  FiChevronRight,
} from "react-icons/fi";


export default function AddClassSubject() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [standardId, setStandardId] = useState("");
  const [selectedSubjects, setSelectedSubjects] = useState([]);
  const [errors, setErrors] = useState({});


  const { classsectionList = [] } = useSelector(
    (state) => state.classsection || {}
  );

  const { subjectlist = [], loading } = useSelector(
    (state) => state.subject || {}
  );

  useEffect(() => {
    dispatch(fetchStandardSection());
    dispatch(getSubject());
  }, [dispatch]);

  const handleCheckboxChange = (id) => {
    setSelectedSubjects((prev) => {
      const updatedSubjects = prev.includes(id)
        ? prev.filter((s) => s !== id)
        : [...prev, id];

      // Clear subject error if at least one subject is selected
      if (updatedSubjects.length > 0) {
        setErrors((prevErrors) => {
          const newErrors = { ...prevErrors };
          delete newErrors.subjects;
          return newErrors;
        });
      }

      return updatedSubjects;
    });
  };
  /*   Validation */
  const validate = () => {
    const newErrors = {};

    if (!standardId) {
      newErrors.standardId = "Please select a standard";
    }

    if (selectedSubjects.length === 0) {
      newErrors.subjects = "Please select at least one subject";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  /* Submit */
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!validate()) return;

    const payload = {
      standardId,
      subjectIds: selectedSubjects,
    };

    dispatch(addClassSubject(payload))
      .unwrap()
      .then(() => {
        toast.success("Subjects added successfully");
        navigate(-1);
      })
      .catch((err) => {
        toast.error(err || "Failed to add subjects");
      });
  };

  return (
    <>
      <div className="page-header">
        <div className="breadcrumb-section">

          <div className="breadcrumb-left">
            <div className="home-icon">
              <Link to="/institute/home"><FiHome style={{ color: "white", marginTop: "-4px" }} /></Link>
            </div>

            <FiChevronRight className="separator" />

            <Link to="/institute/classsubjects">Class Subject</Link>

            <FiChevronRight className="separator" />

            <span className="active">Add Class Subject</span>
          </div>

        </div>
      </div>
      <div className="acs-card">
        <Form onSubmit={handleSubmit}>
          <Row className="g-3">

            {/* Standard Dropdown */}

            <Col md={3} sm={12}>
              <Form.Group>
                <Form.Label>Standard</Form.Label>
                <Form.Select
                  value={standardId}
                  onChange={(e) => {
                    setStandardId(e.target.value);

                    setErrors((prev) => {
                      const newErrors = { ...prev };
                      delete newErrors.standardId;
                      return newErrors;
                    });
                  }}
                >
                  <option value="">Select Standard</option>
                  {classsectionList.map((item) => (
                    <option
                      key={item.standardId?._id}
                      value={item.standardId?._id}
                    >
                      {item.standardId?.name}
                    </option>
                  ))}
                </Form.Select>

                {errors.standardId && (
                  <small className="text-danger">
                    {errors.standardId}
                  </small>
                )}
              </Form.Group>
            </Col>

            {/* Subjects Checkbox */}

            <Col md={12}>
              <Form.Group>
                <Form.Label>Subjects</Form.Label>

                <div className="sa-checkbox-grid">
                  {subjectlist.map((sub) => (
                    <label key={sub._id} className="sa-checkbox-item">
                      <input
                        type="checkbox"
                        checked={selectedSubjects.includes(sub._id)}
                        onChange={() => handleCheckboxChange(sub._id)}
                      />
                      <span>{sub.name}</span>
                    </label>
                  ))}
                </div>

                {errors.subjects && (
                  <small className="text-danger">
                    {errors.subjects}
                  </small>
                )}
              </Form.Group>
            </Col>
          </Row>

          {/* Actions */}

          <div className="sa-actions mt-5">
            <button
              type="button"
              className="btn-cancel"
              style={{ color: "black" }}
              onClick={() => navigate(-1)}
            >
              Cancel
            </button>

            <button
              type="submit"
              className="btn-submit"
              disabled={loading}
            >
              Submit
            </button>
          </div>
        </Form>
      </div>
    </>
  );
}
